import React, { useState,useEffect } from 'react';
import { Button } from 'react-bootstrap';
import DocumentDatatable from '../document/DocumentDatatable';




const DocumentListTab = (props) => {

    
     
    const [entitySubName, setEntitySubName] = useState();
    const [entitySpecify, setEntitySpecify] = useState();    

    useEffect(() => {      
      setEntitySubName(props.entitySubName);
    }, [props.entitySubName])

    const handleEntitySpecify  = (entitySpecify) => {
      setEntitySpecify(entitySpecify);                   
      props.parentCallback(entitySubName,entitySpecify,null);        
    };

    const handleCallback = (id) => {          
          props.parentCallback(entitySubName,entitySpecify,id,true);          
    };
 
 
  
    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
        
          <DocumentDatatable           
            parentCallback={handleCallback}                
            entitySubName={entitySubName}   
            parentCallbackEntitySpecify={handleEntitySpecify}      
            checkTime={props.checkTime}
            showSelectEntitySpecify={true}                 
          />  

          <Button
            bsStyle="primary"
          //  bsSize="large"
            className="ml-3 mt-3"
            onClick={() => handleCallback('')} 
          >
            <i class="fas fa-plus"></i>
          </Button>
        </div>
    );
};

export default DocumentListTab;